import React, { useState, useEffect, Fragment, ReactDOM } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import HandleHttpErrors from "../../HandleHttpErrors";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Edit from "./Edit";
import GetParsedDate from "../../shared/GetParsedDate";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import useAxiosPrivateUploadFile from "../../../hooks/useAxiosPrivateUploadFile";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({
  increment,
  counter,
  setCounter,
  mekhraz_id,
  docOptions,
}) => {
  const [documents, setDocuments] = useState(null);
  const [doc, setDoc] = useState([]);
  const [docId, setDocId] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "mekhrazdocument?mekhraz_id=" + mekhraz_id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          setDocuments(response.data);
          setLoading(false);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          alert(" Anything else");
        }
      }
    };
    getData();
    return () => {
      isMounted = false;
      isMounted && controller.abort();
    };
  }, [counter]);

  const handleEditClick = (event, doc) => {
    event.preventDefault();
    setDocId(doc.id);
  };
  const handleCancelClick = () => {
    setDocId(null);
  };

  if (!documents) return null;
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>המסמך</th>
                      <th>סוג המסמך</th>
                      <th>תאריך העלאה</th>
                      <th>משתמש</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents?.map((doc) => (
                      <Fragment key={doc.id}>
                        {docId === doc.id ? (
                          <Edit
                            doc={doc}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setDocId={setDocId}
                            docOptions={docOptions}
                          />
                        ) : (
                          <ReadOnlyRows
                            doc={doc}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setDocId={setDocId}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  doc,
  handleEditClick,
  setDocId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const axiosPrivateUploadFile = useAxiosPrivateUploadFile();
  const navigate = useNavigate();
  const location = useLocation();

  const handleDownload = async (event, file_url, documentid) => {
    event.preventDefault();
    const fileName = file_url.split("/").pop();
    //console.log(fileName);
    //`${baseURL}mekhrazdocument/${doc.id}/decrypt_file/`,
    try {
      const response = await axiosPrivateUploadFile.get(
        `${baseURL}mekhrazdocument/decrypt_file/?documentid=${documentid}`,
        {
          responseType: "blob", // Set the responseType to 'blob'
        }
      );

      if (response.status === 200) {
        // Create a Blob from the response and trigger a download
        const blob = new Blob([response.data], {
          type: "application/octet-stream",
        });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        console.error("Failed to fetch decrypted file");
      }
    } catch (error) {
      console.error("Error fetching decrypted file:", error);
    }
  };

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(`מחיקת מסמך "${doc.doc_type}": האם אתה בטוח? `);
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const deletePost = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "mekhrazdocument/" + doc.id,
          {
            signal: controller.signal,
          }
        );
        isMounted && increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    deletePost();
    setDocId(null);
  };
  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={doc.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>
          <button
            type="button"
            className="btn btn-sercondary"
            onClick={(event) => handleDownload(event, doc.file_url, doc.id)}
          >
            <u>הורד את המסמך</u>
          </button>
        </td>

        <td>{doc.doc_type}</td>
        <td>
          <GetParsedDate strDate={doc.log_created_at} withTime={true} />{" "}
        </td>
        <td>{doc.created_by_user}</td>
        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, doc)}
          >
            <FiEdit2 />
          </button>
          <span> </span>

          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) => showDeleteModal("documents", doc.id, event)}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
